import { NavigationSubItem } from "../navigation-item"

export class AnalyticsMoreSubItem extends NavigationSubItem {
  readonly id = "analytics"
  readonly label = "Analytics"
  readonly href = "/analytics"
  readonly iconName = "analytics-icon"
  readonly isExternal = false
  readonly tabs = []
}
